import { DatePipe } from '@angular/common';
import { dateFormat } from './payment-card.constants';

export const getBillingPeriodDate = (
  billingPeriodStartDateValue: string,
  billingPeriodEndDateValue: string,
  datePipe: DatePipe,
) => {
  const billingPeriodStartDate = billingPeriodStartDateValue
    ? datePipe.transform(billingPeriodStartDateValue, dateFormat.billPeriod)
    : '';

  const billingPeriodEndDate = billingPeriodEndDateValue
    ? datePipe.transform(billingPeriodEndDateValue, dateFormat.billPeriod)
    : '';

  if (billingPeriodStartDate && billingPeriodEndDate) {
    return `${billingPeriodStartDate} - ${billingPeriodEndDate}`;
  } else {
    return '';
  }
};
